import { SOGetPeriod } from '../period/so-get-period';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';


export class SOPostReport {

  constructor(
    public name: string,
    public active: boolean,
    public project: SOGetProject,
    public organization: SOGetOrganization,
    public description: string = "",
    public period: SOGetPeriod = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostReport(
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
      'active' in params ? params.active : null,
      'period' in params ? params.period : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
    );
  }
}
